var jade = require("/home/romain/Cozy/cozy-proxy/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (t) {
buf.push("<h1>" + (jade.escape(null == (jade_interp = t('setup title')) ? "" : jade_interp)) + "</h1><p class=\"help\">" + (jade.escape(null == (jade_interp = t('setup message')) ? "" : jade_interp)) + "</p><progress value=\"0\" max=\"100\"></progress><h1>" + (jade.escape(null == (jade_interp = t('setup on mobile title')) ? "" : jade_interp)) + "</h1><p class=\"help\">" + (jade.escape(null == (jade_interp = t('setup on mobile message')) ? "" : jade_interp)) + "</p><a href=\"https://play.google.com/store/apps/details?id=io.cozy.files_client\" target=\"_blank\" class=\"btn-store\"><img" + (jade.attr("src", require('../../assets/img/google-play-btn.svg'), true, true)) + " alt=\"Get it on Google Play\"></a>");}.call(this,"t" in locals_for_with?locals_for_with.t:typeof t!=="undefined"?t:undefined));;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./app/views/templates/view_register_setup.jade
 ** module id = 78
 ** module chunks = 0
 **/